import { css } from 'styled-components';
import { latoRegular, robotoMedium, robotoBold, latoBold } from './fonts';

/**
 * Standard pixel text sizes converted to em
 */
export const TextSizes = {
  ThirtyTwo: '2.0em',
  TwentyEight: '1.75em',
  TwentyFour: '1.5em',
  TwentyTwo: '1.375em',
  Twenty: '1.25em;',
  Eighteen: '1.125em',
  Sixteen: '1.0em',
  Fourteen: '0.87em',
  Twelve: '0.75em',
};

/* Themed text-styles may change when design updates from StoneAge are provided */
export const headingOne = css`
  ${robotoBold};
  line-height: ${TextSizes.ThirtyTwo};
  font-size: ${TextSizes.TwentyFour};
`;

export const headingTwo = css`
  ${robotoBold};
  line-height: ${TextSizes.TwentyEight};
  font-size: ${TextSizes.Twenty};
`;

export const headingThree = css`
  ${latoBold}
  font-size: ${TextSizes.Sixteen};
  line-height: ${TextSizes.TwentyTwo};
`;

export const regularBodyText = css`
  ${latoRegular}
  font-size: ${TextSizes.Fourteen};
  line-height: ${TextSizes.Twenty};
`;

export const strongBodyText = css`
  ${latoBold}
  font-size: ${TextSizes.Fourteen};
  line-height: ${TextSizes.Twenty};
`;

export const smallBodyText = css`
  ${latoRegular}
  font-size: ${TextSizes.Twelve};
  line-height: ${TextSizes.Twenty};
`;
/* identical to box height, or 167% */

export const chartText = css`
  ${robotoMedium}
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 1px;
  font-variant: small-caps;
`;
/* identical to box height */

export const formLabel = css`
  ${latoRegular}
  font-size: ${TextSizes.Fourteen};
  line-height: ${TextSizes.Twenty};
`;
